import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dx-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() goTo = true; // determines if go to input is included

  constructor() { }

  ngOnInit() {
  }

}
